import React from "react";
import styled, { css } from "styled-components";

export interface HeaderProps {
  logo: any;
  tib: any;
  user: any;
  breadcrumbs: any;
  logoUrl: string;
  profileUrl: string;
  homeLogo: any;
  burgerLogo: any;
  closeLogo: any;
  collapsed: boolean;
  outLogo: any;
  showBreadcrumbs: any;
  LinkNavigate: any;
  onBurgerClick: () => void;
  onLogout: () => void;
}

const MyHeader = styled.div`
  padding: 0rem 5rem 0rem 5rem;
  height: 5rem;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 85rem;
  margin: 0 auto;
  @media (max-width: 768px) {
  padding: 0rem;
  }
  @media (min-width: 1380px) {
    padding: 0;
  }
`;

const Breadcrumbs = styled.div`
  max-width: 85rem;
  padding: 2rem 5rem 0rem 5rem;
  margin: 0 auto;
  img {
    position: relative;
    top: -10px;
    width: 1.4rem;
    height: 1.4rem;
  }
  a {
    text-decoration:none;
    text-align: left;
    font: normal normal normal 16px/22px Tib;
    letter-spacing: 0px;
    position: relative;
    top: -15px;
    color: #ffffff;
  }
  @media (min-width: 1380px) {
    padding: 2rem 0 0 0;
  }
`;

const BreadcrumbsContainer = styled.div<{ breadcrumbs: [], showBreadcrumbs: [] }>`
  background: #2b2b2b;
  height: 4rem;
  color: white;
  @media (max-width: 768px) {
    display: none;
  }

  ${(props) => props.breadcrumbs && props.breadcrumbs.length > 0
      && props.breadcrumbs.filter((x: { url: never }) => props.showBreadcrumbs.includes(x.url)).length === 0 && css`
    display: none;
  `}
`;

const Email = styled.div`
  color: #8a8b8e;
  font-style: italic;
  @media (max-width: 768px) {
    display: none;
  }
`;

const FlexColumn = styled.div`
display:flex;
flex-direction:row;
@media (max-width: 768px) {
   flex-direction:column;
   justify-content:flex-end;
  }
`;

const UserContainer = styled.div`
  display: flex;
  justify-content:space-between;
  margin: 1rem;
  @media (max-width: 768px) {
    margin-left:6rem;
    margin-right:1rem;
    width:100%;
  }
`;

const UserAvatar = styled.div`
  img{
    width: 2.5rem !important;
    height: 2.5rem !important;
    margin-right: 1rem;
    border-radius: 20px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const Logo = styled.img`
  width: 7rem;
  cursor: pointer;
  @media (max-width: 768px) {
    margin-left:0.5rem;
  }
`;

const TibLogo = styled.div`
  padding-top:1rem;
  img{
    width: 6rem !important;
    margin-right: 2rem;
  }
  @media (max-width: 768px) {
    padding:0;
    img{
      width: 3rem !important;
    }
  }
`;

const Burger = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    position:relative;
    top:10px;
    img {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;

const MenuLogout = styled.a`
  display: "block";
  text-decoration:none;
  cursor:pointer;
  position: relative;
  top:8px;
  img {
    width: 1.7rem;
    height: 1.7rem;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

const ProfileContainer = styled.div`
  margin-right: 2rem;
  @media (max-width: 768px) {
    margin-right: 0.5rem;
  }

  a {
    color: #dd052b;
    text-decoration: none;
    cursor: pointer;
  }
`;

const BreadcrumbsLink = styled.span`
  cursor: pointer;
  font-size: 0.9rem;
`;

const Header: React.FC<HeaderProps> = ({
  logo,
  tib,
  user,
  breadcrumbs,
  logoUrl,
  profileUrl,
  homeLogo,
  burgerLogo,
  outLogo,
  collapsed,
  closeLogo,
  showBreadcrumbs,
  LinkNavigate,
  onBurgerClick,
  onLogout,
}) => (
  <>
    <MyHeader>
      <a href={logoUrl} target="blank">
        <Logo id="logo-ctm" src={logo} alt="logo-ctm" />
      </a>
      <UserContainer>
        <FlexColumn>
          <TibLogo><img src={tib} alt="logo-tib" /></TibLogo>
          <UserAvatar><img src={user.avatar} alt="avatar-usuario" /></UserAvatar>
          <ProfileContainer>
            <LinkNavigate to={profileUrl}>
              Hola, {user.name}
              <Email>{user.email}</Email>
            </LinkNavigate>
          </ProfileContainer>
        </FlexColumn>
        <Burger>
          <img src={collapsed ? closeLogo : burgerLogo} alt="logo-menu" onClick={() => onBurgerClick()} />
        </Burger>
        <MenuLogout onClick={() => onLogout()}>
          <img src={outLogo} alt="salir" />
        </MenuLogout>
      </UserContainer>
    </MyHeader>
    <BreadcrumbsContainer breadcrumbs={breadcrumbs} showBreadcrumbs={showBreadcrumbs}>
      <Breadcrumbs>
        {breadcrumbs
          ? breadcrumbs.map((breadcrumb: any, index: number) => {
            return (
              <BreadcrumbsLink>
                <LinkNavigate key={index} to={breadcrumb.url}>
                  {index === 0 ? (
                    <>
                      <img src={homeLogo} alt="logo-inicio" />
                      <a style={{ marginLeft: "1rem" }}>
                        {breadcrumbs.length === 1 ? "TIB i tu" : null}
                      </a>
                    </>
                  ) : (
                    <a>{`/ ${breadcrumb.label}`}</a>
                  )}
                </LinkNavigate>
              </BreadcrumbsLink>
            );
          })
          : ""}
      </Breadcrumbs>
    </BreadcrumbsContainer>
  </>
);

export default Header;
